<template>
  <div>
    <section class="section">
    
      <a v-bind:href="apiUrl"><font-awesome-icon icon="home" size="2x" /></a> 

      <div class="container">  
        <div class="box has-background-light" >
  
  <h1 class="title is-3 has-text-centered has-text-info">Publiez une offre d'emploi en télétravail</h1>

    <p class="content is-medium has-text-centered">
        Tarif pour une annonce <strong>premium</strong> épinglée en haut de la page d'accueil : <strong>15 euros</strong> pour une durée de 30 jours
        <br/>- c'est<strong> un unique paiement</strong>, pas d'abonnement à payer -
    </p>
    <br/><br/>

    <form id="signup-form" @submit.prevent="processForm">

      <!-- jobtitre -->
      <div class="field">
        <label class="label">Titre du job *</label>
        <input type="text" class="input" name="jobtitre" v-model="jobtitre">
      </div>

      <!-- company -->
      <div class="field">
        <label class="label">Entreprise *</label>
        <input type="text" class="input" name="company" v-model="company">
      </div>

      <!-- location -->
      <div class="field">
        <label class="label">Localisation (à préciser au cas où accessible uniquement dans certains pays)</label>
        <input type="text" class="input" name="location" v-model="location">
      </div>

      <!-- salary -->
      <div class="field">
        <label class="label">Salaire annuel ou équivalent (si la durée n'est pas annuelle, convertir en équivalent annuel)</label>
        <input type="text" class="input" name="salary" placeholder="... mention facultative"  v-model="salary">
      </div>

      <div>
        <br/>
      </div>

      <span class="is-medium">
        <p> 
          <strong>Sélectionner une catégorie de job * </strong>
        </p>
      </span>
       
      <b-field grouped group-multiline>
            <!-- multiline parameter is for responsive multiline on mobile device -->
            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="informatique"
                type="is-success">
                informatique
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="fico"
                type="is-success">
                comptabilité et gestion
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="vente"
                type="is-success">
                commercial
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="rh"
                type="is-success">
                ressources humaines
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="creatif"
                type="is-success">
                créatif
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="divers"
                type="is-success">
                autre
            </b-checkbox-button>
            </b-field>

      </b-field>

      <div>
        <br/>
      </div>
          
      <!-- description -->
      <div class="field">
      <label class="label">Description du poste *</label>
        <textarea class="textarea" v-model="description"></textarea>
      </div>

      <!-- profil -->
      <div class="field">
      <label class="label">Profil recherché</label>
        <textarea class="textarea" placeholder="... mention facultative" v-model="profil"></textarea>
      </div>

      <!-- howto -->
      <div class="field">
      <label class="label">Comment postuler ?</label>
        <textarea class="textarea" placeholder="... mention facultative" v-model="howto"></textarea>
      </div>


      <div class="box has-background-light" >
        <div>
          <br/>
          <p>
            <em>indiquez une URL (adresse web) OU un email pour postuler *</em>
          </p>
          <br/>
        </div>
      
        <!-- urljob -->
        <div v-if="emailjob == ''"" class="field" >
          <label class="label">Url pour postuler</label>
          <b-field>
            <b-input placeholder="https://example.com (copier coller votre lien ici)" type="url" 
            name="urljob" v-model="urljob"></b-input>
          </b-field>
        </div>

        <!-- emailjob -->
        <div v-if="urljob == ''" class="field">
          <label class="label">Email pour postuler (information publique)</label>
          <input type="email" class="input" name="emailjob" v-model="emailjob" >
        </div>

      </div>

      <!-- addinfo -->
      <div class="field">
      <label class="label">Informations complémentaires</label>
        <textarea class="textarea" placeholder="... mention facultative" v-model="addinfo"></textarea>
      </div>

      <!-- emailinvoice -->
      <div class="field">
        <label class="label">Email entreprise pour réception de la facture * (cette information n'est pas publiée)</label>
        <input type="email" class="input" name="emailinvoice" v-model="emailinvoice">
      </div>

      <!-- address -->
      <div class="field">
        <label class="label">Adresse de facturation (cette information n'est pas publiée)</label>
        <input type="text" class="input" name="address" placeholder="... mention facultative" v-model="address">
      </div>

      <div>
        <br/>
        <p>
          <em>Prochaine étape : paiement sécurisé crypté en SSL garanti par la société Stripe</em>
        </p>
        <br/>
      </div>

      <p v-if="errors.length">
      <b>Merci de corriger les points suivants :</b>
      <ul>
        <li v-for="error in errors">{{ error }}</li>
      </ul>
      </p>

      <!-- submit button -->
      <div class="field has-text-right">
        <button type="submit" class="button is-primary">Publier un job</button>
      </div>
    </form>

       </div>
      </div>
    </section>

  </div>    
</template>

<script>
import axios from 'axios'

export default {
    data () {
            return {
              jobtitre: null,
              company: null,
              location: "international",
              salary: null,
              checkboxGroup: [],
              description: null,
              profil: null,
              howto: null,
              urljob: '',
              emailjob: '',
              addinfo: null,
              emailinvoice: null,
              address: null,
              apiUrl : '',
              errors: []
            }
    }, 

    methods: {    
      callcheckout(payload) {
      /* test key
    var stripe = Stripe('pk_test_51GrHy0Anl65KsgcoKiQkh6Jk8ZklhZFKBpx1EHmmwf58W7bZOx7dKwuKeLRcnGBHqS2wFJebseWbhKDXCXuuWWAe00DsAIzUL9');
    */
        var stripe = Stripe('pk_live_IjCNV2P2vVqT4OFrTPzqqlTa00cv89B4wS');
        var api_url = this.apiUrl;
        api_url += '/checkout';
        axios.post(api_url, payload)
          .then(response => {
            stripe.redirectToCheckout({sessionId: response.data.sessionId})
          })
            .then(function(result) {
              if (result.error) {
                console.log('erreur redirectToCheckout');
                console.log(result.error);
              }
            })
      }, 
      processForm () {
        let self = this;
        this.errors = [];
        if(!this.jobtitre) this.errors.push("Titre du job : mention obligatoire");
        if(!this.company) this.errors.push("Nom de l'entreprise : mention obligatoire");
        if(!this.description) this.errors.push("Description du job : mention obligatoire");
        if(this.checkboxGroup.length > 1) this.errors.push("Sélectionnez une seule catégorie de job");
        if(this.checkboxGroup.length == 0) this.errors.push("Sélectionnez une catégorie de job");
        if (!this.jobtitre || !this.company) this.errors.push("Indiquez une URL (adresse web) OU un email pour postuler ");
        if(!this.emailinvoice) this.errors.push("Email entreprise pour réception de la facture : mention obligatoire");
        if (this.errors.length > 0) {
          alert("Merci de compléter les informations");
        } else {
            var category = this.checkboxGroup[0];
            const payload = {
            jobtitre: self.jobtitre,
            company: self.company,
            location: self.location,
            salary: self.salary,
            category: category,
            description: self.description,
            profil: self.profil,
            howto: self.howto,
            urljob: self.urljob,
            emailjob: self.emailjob,
            addinfo: self.addinfo,
            emailinvoice: self.emailinvoice,
            address: self.address
            };
            this.callcheckout(payload);
        }
      }
    }, 
    created () {
      this.apiUrl = process.env.API_URL;
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Publierjob.vue